import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Select, { components } from 'react-select';

import ClearIcon from './clear_filter_icon';

import './select_filter.scss';

const Control = props => <components.Control className="form-select py-1" {...props} />;

const IndicatorsContainer = () => null;

const Menu = props => (
  <div className="select-filter-menu">
    <components.Menu {...props} />
  </div>
);

const FixedMenu = props => (
  <div className="select-filter-menu">
    <components.Menu {...props} />
  </div>
);

const MenuList = props => (
  <components.MenuList {...props} />
);

export function buildSelectContainer(className) {
  return function Container(props) {
    return (
      <div className={classNames('', className)}>
        <components.SelectContainer {...props} />
      </div>
    );
  };
}


export default class SelectFilter extends React.Component {
  static propTypes = {
    autoWidth: PropTypes.bool,
    componentOverrides: PropTypes.object,
    menuPosition: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func,
  };

  static defaultProps = {
    // TODO: BS5 - When *wouldnt* you want this? Should we remove the prop entirely?
    menuPosition: 'fixed',
  }

  render() {
    const { componentOverrides, onClear, ...selectProps } = this.props;

    let containerClassName = '';
    if (this.props.autoWidth) {
      containerClassName = 'auto-width';
    }
    const SelectContainer = buildSelectContainer(containerClassName);

    const components = {
      Control,
      IndicatorsContainer: IndicatorsContainer,
      Menu,
      MenuList,
      SelectContainer,
      ...componentOverrides
    };

    if (selectProps.menuPosition === 'fixed') {
      components.Menu = FixedMenu;
    }

    if (onClear) {
      components.IndicatorsContainer = () => <ClearIcon onClear={onClear} />;
    }

    // Styles are hacks to look like .btn-outline
    // TODO: Clean up the whole component tree in some way
    // * NOTE: Custom styles from Blueprint have been applied to override the styles from react-select. 
    // *       These should be removed when we migrate to Blueprint's React Select.
    return (
      <Select
        classNames={{
          menuList: () => 'dropdown-menu show',
          menuPortal: () => 'dropdown show',
          option: state => `dropdown-item ${state.isSelected ? 'active' : ''}`,
        }}
        components={components}
        isSearchable
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: `${state.isFocused ? 'oklch(81.36% 0.09 249.96 / 1)' : 'oklch(88.69% 0.01 259.82 / 1)'}`,
            borderWidth: 1,
            borderRadius: 6,
            boxShadow: 'none',
            minHeight: 37,
            height: 37,
          }),
          menu: base => ({
            ...base,
            marginTop: 4,
            boxShadow: 'none',
            borderRadius: 6,
          }),
          menuList: base => ({
            ...base,
            minWidth: '100%',
            width: 'fit-content',

          }),
          menuPortal: base => ({
            ...base,
            zIndex: 1080,
          }),
          option: () => ({}),
          input: base => ({
            ...base,
            margin: 0,
            padding: 0,
          }),
          valueContainer: base => ({
            ...base,
            padding: 0,
          }),
        }}
        {...selectProps}
      />
    );
  }
}
